import { render, staticRenderFns } from "./bookingsByPlacePage.vue?vue&type=template&id=04b42904&scoped=true&"
import script from "./bookingsByPlacePage.vue?vue&type=script&lang=ts&"
export * from "./bookingsByPlacePage.vue?vue&type=script&lang=ts&"
import style0 from "./bookingsByPlacePage.vue?vue&type=style&index=0&id=04b42904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b42904",
  null
  
)

export default component.exports